import { Table } from "antd";
import { BaseTable } from "@/components/TableComponents";
import globalQuoteStrategy from "@/common/strategies/quotes/globalQuote.strategy";
import {
  vendorQuoteLineSubTable,
  customerQuoteLineSubTable,
} from "@/common/strategies/quotes/quoteLineSubTable";
import { ColumnsStrategy, CompanyType, QuotesType } from "@/common/types";
import { usePermissions } from "@/common/contexts/Permissions.context";
import vendorQuoteStrategy from "@/common/strategies/quotes/vendorQuote.strategy";
import customerGlobalStrategy from "@/common/strategies/quotes/quotesGlobalCustomer.strategy";
import { useNavigate } from "react-router";

const pickStrategy: (
  companyType: CompanyType,
  productType: QuotesType
) => ColumnsStrategy[] = (companyType, productType) => {
  switch (companyType) {
    case "vendor":
      return vendorQuoteLineSubTable[productType];
    case "customer":
      return customerQuoteLineSubTable[productType];
    default:
      return [];
  }
};

export default function QuoteList({
  data,
  scrollY,
}: {
  data: any;
  scrollY?: number;
}) {
  const { company } = usePermissions();
  const navigate = useNavigate();

  const expandedRowRender = (record: any) => {
    if (company?.companyType === "customer") {
      if (record.quoteLines.length === 0) {
        // message.error("No quote lines");
        return;
      }

      return (
        <div>
          <BaseTable
            data={record.quoteLines}
            strategy={pickStrategy("customer", record.productType)}
            onRowClick={(recordData: any) => {
              return navigate(
                `/quoteLine/customer/${recordData.quoteId}/${recordData.id}`,
                {
                  state: {
                    quoteData: { ...record, type: record.productType },
                    quoteLineData: { ...recordData, quote: { ...record } },
                  },
                }
              );
            }}
          />
        </div>
      );
    }
    return (
      <div className="w overflow-x-auto">
        <BaseTable
          data={record.quoteLines.map((el: any) => ({
            ...el,
            status: record.status,
          }))}
          strategy={pickStrategy(company?.companyType, record.type)}
          rowClassName={() => "cursor-pointer"}
          onRowClick={(recordData: any) => {
            switch (company?.companyType) {
              case "vendor":
                return navigate(
                  `/quoteLine/vendor/${record.id}/${recordData?.id}`
                );
              case "airx":
                return navigate(
                  `/quoteLine/airx/${record.id}/${recordData.id}`,
                  {
                    state: {
                      quoteData: record,
                      quoteLineData: recordData,
                    },
                  }
                );

              default:
                break;
            }
          }}
        />
      </div>
    );
  };
  switch (company?.companyType) {
    case "vendor":
      return (
        <Table
          tableLayout="auto"
          scroll={{ x: "max-content", y: scrollY }}
          dataSource={data}
          expandable={{
            expandedRowRender,
            expandRowByClick: true,
            showExpandColumn: false,
          }}
          columns={vendorQuoteStrategy}
          rowKey="id"
          pagination={false}
          rowClassName={() => {
            return "!py-0 cursor-pointer bg-transparent";
          }}
        />
      );
    case "customer":
      return (
        <Table
          tableLayout="auto"
          scroll={{ x: "max-content", y: scrollY }}
          dataSource={data}
          expandable={{
            expandedRowRender,
            expandRowByClick: true,
            showExpandColumn: false,
          }}
          columns={customerGlobalStrategy}
          rowKey="quoteReqId"
          pagination={false}
          rowClassName={() => {
            return "!py-0 cursor-pointer bg-transparent";
          }}
        />
      );
    default:
      return (
        <Table
          tableLayout="auto"
          scroll={{ x: "max-content" }}
          dataSource={data}
          expandable={{
            expandedRowRender,
            expandRowByClick: true,
            showExpandColumn: false,
          }}
          columns={globalQuoteStrategy}
          rowKey="id"
          pagination={false}
          rowClassName={() => {
            return "!py-0 cursor-pointer bg-transparent";
          }}
        />
      );
  }
}
